import React from "react";
import { Helmet} from "react-helmet-async";
import banner from "../assets/lb/artbanner.png";
import "./Home.css"

function HomePage() {
  return (
    <>
      <Helmet>
        <title>Lia | Home</title>
      </Helmet>
      <div className="home">
        <h1>Welcome to the <span>Lialab</span> NFT Collection</h1>
        <img className="rounded" src={banner} alt="Hero Banner" />
      </div>
      <div className="textunderbanner">
        <h5>
        Lia Lab is an AI-powered ecosystem on the <span>Abstract blockchain</span>, 
        seamlessly blending innovative technologies with a 3D animated NFT collection.
         At its core is <span>Lia</span>, our intelligent AI assistant,
          offering utilities such as DAO governance, staking, rewards, NFT leasing, and gaming integration.
           As a community-driven platform, Lia Lab empowers users to engage, earn, and shape the future of NFTs.
        </h5>
      </div>
    </>
  );
}

export default HomePage;